import { PaymentType } from '../enums/payment-type';
import { IPaymentMethod } from './i-payment-method';
import { IProduct } from './i-product';

export interface ICartItem {
  quantity: number;
  paymentType: PaymentType;
  product: IProduct;
  entity: ICartItemEntity;
}

export interface ICartItemEntity {
  entityId: string;
  locationId: string;
  productId: string;
  price: number;
  name: string;
  minimumOrderQuantity: number;
  maximumOrderQuantity: number;
  stockCount: number;
  enforceStockChecks: boolean;
  maximumAvailableOrderQuantity: number;
  paymentMethods: IPaymentMethod[];
}
